<div class="edit-button">
    <ct-gradient-text class="edit-button-text">
        <ng-content></ng-content>
    </ct-gradient-text>
    <div class="edit-button-icon"></div>
</div>
